import React, { useState } from 'react';
import { usePlatform } from '../../contexts/PlatformContext';
import { useUserRole } from '../../contexts/UserRoleContext';
import './PlatformDebugPanel.css';

/**
 * Internal platform context inspector — dev or super_admin only.
 * Does not render branding HTML or custom_css.
 */
export const PlatformDebugPanel: React.FC = () => {
  const {
    hostname,
    tenant,
    appSlug,
    enabled,
    branding,
    usedFallback,
    isLoading,
    error,
  } = usePlatform();
  const { hasRole } = useUserRole();
  const [collapsed, setCollapsed] = useState(false);

  const isDev = process.env.NODE_ENV === 'development';
  const isSuperAdmin = hasRole('super_admin');

  if (!isDev && !isSuperAdmin) {
    return null;
  }

  return (
    <aside
      className={`platform-debug-panel${collapsed ? ' platform-debug-panel--collapsed' : ''}`}
      aria-label="Platform context debug"
    >
      <button
        type="button"
        className="platform-debug-panel__toggle"
        onClick={() => setCollapsed((value) => !value)}
      >
        Platform {collapsed ? '▸' : '▾'}
      </button>
      {!collapsed && (
        <dl className="platform-debug-panel__list">
          <div>
            <dt>hostname</dt>
            <dd>{hostname}</dd>
          </div>
          <div>
            <dt>tenant</dt>
            <dd>{tenant ? `${tenant.slug} (${tenant.display_name})` : '—'}</dd>
          </div>
          <div>
            <dt>app_slug</dt>
            <dd>{appSlug}</dd>
          </div>
          <div>
            <dt>enabled</dt>
            <dd>{enabled ? 'true' : 'false'}</dd>
          </div>
          <div>
            <dt>product_name</dt>
            <dd>{branding.product_name ?? '—'}</dd>
          </div>
          <div>
            <dt>fallback</dt>
            <dd>{usedFallback ? 'yes' : 'no'}</dd>
          </div>
          <div>
            <dt>loading</dt>
            <dd>{isLoading ? 'yes' : 'no'}</dd>
          </div>
          {error && (
            <div>
              <dt>error</dt>
              <dd>{error}</dd>
            </div>
          )}
        </dl>
      )}
    </aside>
  );
};

export default PlatformDebugPanel;
